import React from 'react'

import AccountOverviewData from './AccountOverviewData/AccountOverviewData'
import AccountOverviewOrders from './AccountOverviewOrders/AccountOverviewOrders'
import AccountOverviewAddress from './AccountOverviewAddress/AccountOverviewAddress'
import AccountOverviewMachines from './AccountOverviewMachines/AccountOverviewMachines'
import AccountOverviewPaymentMethod from './AccountOverviewPaymentMethod/AccountOverviewPaymentMethod'
import AccountOverviewPrivacySettings from './AccountOverviewPrivacySettings/AccountOverviewPrivacySettings'
import AccountOverviewWishlist from './AccountOverviewWishlist/AccountOverviewWishlist'
import * as S from './AccountOverview.styles'

const AccountOverview = () => {
  return (
    <div className={S.MainWrapper}>
      <AccountOverviewOrders className={S.OrderListWrapper} />
      <AccountOverviewWishlist />
      <div className={S.DataAndAddressWrapper}>
        <AccountOverviewData className={S.LeftItemWrapper} />
        <AccountOverviewAddress />
      </div>
      <div className={S.PaymentsAndPrivacyWrapper}>
        <AccountOverviewPaymentMethod className={S.LeftItemWrapper} />
        <AccountOverviewPrivacySettings />
      </div>
      <AccountOverviewMachines className={S.MachinesWrapper} />
    </div>
  )
}

export default AccountOverview
